import { React, useState, useEffect } from 'react';
import { Nav, Row, Col, Form, Modal, Button } from 'react-bootstrap';
import '../../settingscommon.scss';
import '../../User/user.scss';
import '../../EmailProvider/emailprovider.scss';
import { Link } from 'react-router-dom';
import warningIcon from '../../../../assets/images/warningIcon.svg';
import EyeIcon from '../../../../assets/images/eye_icon.svg';
import { useMutation, useLazyQuery } from '@apollo/client';
import { TEST_SMTP, CREATE_SMTP, REMOVE_SMTP_LINK } from '../../../../gql/smtp/mutation';
import { toast } from 'react-toastify';
import useUnsavedChangeWarning from 'hooks/useUnsavedChangeWarning';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from 'react-router-dom';
import { GET_ALL_SMTP_AND_IMAP_DATA } from '../../../../gql/smtp/queries';
import { Spinner } from 'react-bootstrap';
// import rightArrow from '../../../../assets/images/right-arrow.svg';

function Smtp({ history }) {
    const [smtpPasswordShown, setSmtpPasswordShown] = useState(false);
    const [imapPasswordShown, setImapPasswordShown] = useState(false);
    const [smtpErros, setSmtpErrors] = useState({})
    const [imapErros, setImapErrors] = useState({})
    const [Prompt, setIsDirty, setPristine] = useUnsavedChangeWarning()

    const [senderEmail, setSenderEmail] = useState('')
    const [senderName, setSenderName] = useState('')

    const [smtpUserName, setSmtpUserName] = useState('')
    const [smtpPassword, setSmtpPassword] = useState('')
    const [smtpServeraddress, setSmtpServeraddress] = useState('')
    const [smtpPort, setSmtpPort] = useState('')
    const [smtpSsl, setSmtpSsl] = useState(false)

    const [imapUserName, setImapUserName] = useState('')
    const [imapPassword, setImapPassword] = useState('')
    const [imapServeraddress, setImapServeraddress] = useState('')
    const [imapPort, setImapPort] = useState('')
    const [imapSsl, setImapSsl] = useState(false)

    const [allFormData, setAllFormData] = useState({})

    const [removed, setRemoved] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [createdSmtp, setCreatedSmtp] = useState(false)
    const [testSmtpSuccess, setTestSmtpSuccess] = useState(false)

    const userInfo = JSON.parse(localStorage.getItem('user'))
    const tested = userInfo?.smtpTested
    const saved = userInfo?.smtpSaved
    const [smtpTested, setSmtpTested] = useState(tested);
    const [smtpSaved, setSmtpSaved] = useState(saved);
    const [showUnlikButton, setShowUnlinkButton] = useState(false);

    const [testSmtp, { loading }] = useMutation(TEST_SMTP, {
        onCompleted(data) {
            setTestSmtpSuccess(true)
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        }
    })

    const [createSmtp, { loading: createLoading, data: savedSmtpData }] = useMutation(CREATE_SMTP, {
        onCompleted(data) {
            setShowUnlinkButton(true)
            setCreatedSmtp(true)
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        }
    })

    const [loadSmtpImapData, { data }] = useLazyQuery(GET_ALL_SMTP_AND_IMAP_DATA, {
        onCompleted(data) {
            if (data?.getSmtp?.smtp?.port) {
                setSenderEmail(data?.getSmtp?.smtp?.senderEmail)
                setSenderName(data?.getSmtp?.smtp?.senderName)
                setSmtpUserName(data?.getSmtp?.smtp?.userName)
                setSmtpPassword(data?.getSmtp?.smtp?.password)
                setSmtpServeraddress(data?.getSmtp?.smtp?.host)
                setSmtpPort(data?.getSmtp?.smtp?.port)
                setSmtpSsl(data?.getSmtp?.smtp?.ssl)
            }
            if (data?.getSmtp?.imap?.port) {
                setImapUserName(data?.getSmtp?.imap?.userName)
                setImapPassword(data?.getSmtp?.imap?.password)
                setImapServeraddress(data?.getSmtp?.imap?.host)
                setImapPort(data?.getSmtp?.imap?.port)
                setImapSsl(data?.getSmtp?.imap?.ssl)
            }
        },
        fetchPolicy: "network-only",
    })

    const [removeSmtpLink] = useMutation(REMOVE_SMTP_LINK, {
        onCompleted(data) {
            if (data) {
                let user = {
                    ...userInfo,
                    smtpTested: false,
                    smtpSaved: false
                }
                localStorage.setItem('user', JSON.stringify(user))
                setRemoved(true)
            }
        },
        refetchQueries: ['Me', 'GetSmtp'],
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        }
    })

    useEffect(() => {
        loadSmtpImapData()

        return () => {
            if(savedSmtpData){
                let user = {
                    ...userInfo,
                    smtpSaved: true
                }
                localStorage.setItem('user', JSON.stringify(user))
            }
            else{
                let user = {
                    ...userInfo,
                    smtpSaved: false
                }
                localStorage.setItem('user', JSON.stringify(user))
            }
        }
        // eslint-disable-next-line
    }, [createdSmtp])

    // Password toggle handler
    const toggleSmtpPassword = () => {
        setSmtpPasswordShown(!smtpPasswordShown);
    };

    const toggleImapPassword = () => {
        setImapPasswordShown(!imapPasswordShown);
    };
    const [smShow, setSmShow] = useState(false);

    // const preventClick = (e) => {
    //     e.preventDefault();
    // }

    const handleSmtpForm = (e) => {
        e.preventDefault()

        if (smtpUserName && smtpPassword && smtpServeraddress && smtpPort && senderEmail && senderName && /\S+@\S+\.\S+/.test(senderEmail)) {
            const smtp = {
                userName: smtpUserName,
                password: smtpPassword,
                host: smtpServeraddress,
                port: +smtpPort,
                ssl: smtpSsl,
                senderEmail: senderEmail, //new
                senderName: senderName, //new
            }
            setAllFormData({
                ...allFormData,
                smtp
            })
            testSmtp({
                variables: {
                    smtpInputType: {
                        ...smtp,
                        protocol: 'SMTP',
                        senderEmail: senderEmail,
                        senderName: senderName,
                    }
                }
            })
        }

        if (!senderEmail) {
            setSmtpErrors((prev) => ({
                ...prev,
                senderEmail: 'Sender email is required.'
            }))
        }
        if (senderEmail && !/\S+@\S+\.\S+/.test(senderEmail)) {
            setSmtpErrors((prev) => ({
                ...prev,
                senderEmail: 'Sender email is invalid.'
            }))
        }
        if (!senderName.trim()) {
            setSmtpErrors((prev) => ({
                ...prev,
                senderName: 'Sender name is required.'
            }))
        }
        if (!smtpUserName) {
            setSmtpErrors((prev) => ({
                ...prev,
                smtpUserName: 'User name is required.'
            }))
        }
        if (!smtpPassword) {
            setSmtpErrors((prev) => ({
                ...prev,
                smtpPassword: 'Password is required.'
            }))
        }
        if (!smtpServeraddress) {
            setSmtpErrors((prev) => ({
                ...prev,
                smtpServeraddress: 'Server address is required.'
            }))
        }
        if (!smtpPort) {
            setSmtpErrors((prev) => ({
                ...prev,
                smtpPort: 'Port is required'
            }))
        }

    }

    const handleImapForm = (e) => {
        e.preventDefault()
        const imap = {
            userName: imapUserName,
            password: imapPassword,
            host: imapServeraddress,
            port: +imapPort,
            ssl: imapSsl
        }
        setAllFormData({
            ...allFormData,
            imap
        })
    }

    const senderEmailHandler = (e) => {
        if (!senderEmail) {
            setSmtpErrors((prev) => ({
                ...prev,
                senderEmail: 'Sender email is required.'
            }))
        }
        if (senderEmail && !/\S+@\S+\.\S+/.test(senderEmail)) {
            setSmtpErrors((prev) => ({
                ...prev,
                senderEmail: 'Sender email is invalid.'
            }))
        }
    }

    const senderNameHandler = (e) => {
        if (!senderName.trim()) {
            setSmtpErrors((prev) => ({
                ...prev,
                senderName: 'Sender name is required.'
            }))
        }
    }

    const smtpUserNameHandler = (e) => {
        if (!smtpUserName) {
            setSmtpErrors((prev) => ({
                ...prev,
                smtpUserName: 'User name is required.'
            }))
        }
    }

    const smtpPasswordHandler = (e) => {
        if (!smtpPassword) {
            setSmtpErrors((prev) => ({
                ...prev,
                smtpPassword: 'Password is required.'
            }))
        }
    }

    const smtpServerAddressHandler = (e) => {
        if (!smtpServeraddress) {
            setSmtpErrors((prev) => ({
                ...prev,
                smtpServeraddress: 'Server address is required.'
            }))
        }
    }

    const smtpPortHandler = (e) => {
        if (!smtpPort) {
            setSmtpErrors((prev) => ({
                ...prev,
                smtpPort: 'Port is required'
            }))
        }
    }

    const imapUserNameHandler = (e) => {
        if (!imapUserName) {
            setImapErrors((prev) => ({
                ...prev,
                imapUserName: 'User name is required.'
            }))
        }
    }

    const imapPasswordHandler = (e) => {
        if (!imapPassword) {
            setImapErrors((prev) => ({
                ...prev,
                imapPassword: 'Password is required.'
            }))
        }
    }

    const imapServerAddressHandler = (e) => {
        if (!imapServeraddress) {
            setImapErrors((prev) => ({
                ...prev,
                imapServeraddress: 'Server address is required.'
            }))
        }
    }

    const imapPortHandler = (e) => {
        if (!imapPort) {
            setImapErrors((prev) => ({
                ...prev,
                imapPort: 'Port is required'
            }))
        }
    }

    const handleSave = (e) => {

        if (!senderEmail) {
            setSmtpErrors((prev) => ({
                ...prev,
                senderEmail: 'Sender email is required.'
            }))
        }
        if (senderEmail && !/\S+@\S+\.\S+/.test(senderEmail)) {
            setSmtpErrors((prev) => ({
                ...prev,
                senderEmail: 'Sender email is invalid.'  
            }))
        }
        if (!senderName.trim()) {
            setSmtpErrors((prev) => ({
                ...prev,
                senderName: 'Sender name is required.'
            }))
        }
        if (!smtpUserName) {
            setSmtpErrors((prev) => ({
                ...prev,
                smtpUserName: 'User name is required.'
            }))
        }
        if (!smtpPassword) {
            setSmtpErrors((prev) => ({
                ...prev,
                smtpPassword: 'Password is required.'
            }))
        }
        if (!smtpServeraddress) {
            setSmtpErrors((prev) => ({
                ...prev,
                smtpServeraddress: 'Server address is required.'
            }))
        }
        if (!smtpPort) {
            setSmtpErrors((prev) => ({
                ...prev,
                smtpPort: 'Port is required'
            }))
        }

        if (imapUserName) {
            if (!imapPassword) {
                return setImapErrors((prev) => ({
                    ...prev,
                    imapPassword: 'Password is required.'
                }))
            }
            if (!imapServeraddress) {
                return setImapErrors((prev) => ({
                    ...prev,
                    imapServeraddress: 'Server address is required.'
                }))
            }
            if (!imapPort) {
                return setImapErrors((prev) => ({
                    ...prev,
                    imapPort: 'Port is required'
                }))
            }

        }

        if (imapPassword) {
            if (!imapUserName) {
                return setImapErrors((prev) => ({
                    ...prev,
                    imapUserName: 'User name is required.'
                }))
            }
            if (!imapServeraddress) {
                return setImapErrors((prev) => ({
                    ...prev,
                    imapServeraddress: 'Server address is required.'
                }))
            }
            if (!imapPort) {
                return setImapErrors((prev) => ({
                    ...prev,
                    imapPort: 'Port is required'
                }))
            }
        }

        if (imapServeraddress) {
            if (!imapUserName) {
                return setImapErrors((prev) => ({
                    ...prev,
                    imapUserName: 'User name is required.'
                }))
            }
            if (!imapPassword) {
                return setImapErrors((prev) => ({
                    ...prev,
                    imapPassword: 'Password is required.'
                }))
            }
            if (!imapPort) {
                return  setImapErrors((prev) => ({
                    ...prev,
                    imapPort: 'Port is required'
                }))
            }
        }

        if (imapPort) {
            if (!imapUserName) {
                return setImapErrors((prev) => ({
                    ...prev,
                    imapUserName: 'User name is required.'
                }))
            }
            if (!imapPassword) {
                return setImapErrors((prev) => ({
                    ...prev,
                    imapPassword: 'Password is required.'
                }))
            }
            if (!imapServeraddress) {
                return setImapErrors((prev) => ({
                    ...prev,
                    imapServeraddress: 'Server address is required.'
                }))
            }
        }

        if (smtpUserName && smtpPassword && smtpServeraddress && smtpPort && senderEmail && senderName && /\S+@\S+\.\S+/.test(senderEmail)) {
            const smtp = {
                userName: smtpUserName,
                password: smtpPassword,
                host: smtpServeraddress,
                port: +smtpPort,
                ssl: smtpSsl
            }
            const imap = {
                userName: imapUserName,
                password: imapPassword,
                host: imapServeraddress,
                port: +imapPort,
                ssl: imapSsl
            }
            createSmtp({
                variables: {
                    smtpInput: {
                        imap: {
                            ...imap,
                            protocol: 'IMAP',
                            senderEmail: senderEmail,
                            senderName: senderName,
                        },
                        smtp: {
                            ...smtp,
                            protocol: 'SMTP',
                            senderEmail: senderEmail,
                            senderName: senderName,
                        },
                    }
                }
            })
        }

    }

    const handleUnlink = () => {
        removeSmtpLink()
    }

    if (removed) {
        history.push('/settings/email-provider')
    }

    if (errorMessage) {
        let user = {
            ...userInfo,
            smtpTested: false
        }
        localStorage.setItem('user', JSON.stringify(user))
        setSmtpTested(false)
        toast.error(errorMessage, {
            position: "bottom-right",
            closeOnClick: true,
        })
        setErrorMessage('')
    }

    if (createdSmtp) {
        setPristine()
        let user = {
            ...userInfo,
            smtpSaved: true
        }
        localStorage.setItem('user', JSON.stringify(user))
        setSmtpSaved(true) 

        // setShowUnlinkButton(true)
        toast.success("Successfully Saved.", {
            position: "bottom-right",
            closeOnClick: true,
        })
        setCreatedSmtp(false)
    }

    if (testSmtpSuccess) {
        let user = {
            ...userInfo,
            smtpTested: true
        }
        localStorage.setItem('user', JSON.stringify(user))
        setSmtpTested(true)
        setSmtpSaved(true) 
        toast.success("Please Check Your Inbox For Test Mail.", {
            position: "bottom-right",
            closeOnClick: true,
        })
        setTestSmtpSuccess(false)
    }

    const handleUnlinkButton = () => {
        if (showUnlikButton || data?.getSmtp?.smtp) {
            return setSmShow(true)
        }
        if (!showUnlikButton || !data) {
            history.push('/settings/email-provider')

        }

    }

    return <>
        <div>
            <h1 className='page-title'>Settings</h1>
            <Nav
                className='setting-menu'
            >
                <Nav.Item>
                    <Link to="/settings/user" className='nav-link'>User</Link>
                </Nav.Item>
                <Nav.Item>
                    <Link to="/settings/email-provider" className='nav-link active'>Email Provider</Link>
                </Nav.Item>
                <Nav.Item>
                    <Link to="/settings/text-provider" className='nav-link'>Text Provider</Link>
                </Nav.Item>
                <Nav.Item>
                    <Link to="/settings/email-signature" className='nav-link'>Email Signature</Link>
                </Nav.Item>
                {/* <Nav.Item>
                    <Link to="/settings/billing" className='nav-link'>Billing</Link>
                </Nav.Item> */}
            </Nav>
            <div className='profile-sec'>
                {/* <div style={{ display: showUnlikButton === true || data ? 'none' : 'block' }} >
                    <Link className="back-btn" to='/settings/email-provider'>
                        <img src={rightArrow} alt="Back" />
                        Back
                    </Link>
                </div> */}
                <p className='btn_container_p'>You are using a custom SMTP / IMAP email provider.
                    {/* <button className='solid-button' style={{ display: showUnlikButton === true || data ? 'block' : 'none' }} onClick={handleUnlinkButton}>Choose another email provider</button> */}
                    <button className='solid-button' onClick={handleUnlinkButton}>Choose Another Email Provider</button>
                </p>
                <div className='settings-div'>
                    <h4>Sender settings</h4>
                    <Row className="mb-5 mt-3">
                        <Col sm={6}>
                            <Form.Group controlId="senderEmail">
                                <Form.Label>Sender Email</Form.Label>
                                <Form.Control
                                    name="senderEmail"
                                    type="text"
                                    placeholder=""
                                    value={senderEmail}
                                    onChange={(e) => {
                                        setSenderEmail(e.target.value)
                                        setSmtpErrors({})
                                        setIsDirty()
                                    }
                                    }
                                    onBlur={senderEmailHandler}
                                    className={smtpErros.senderEmail ? 'error' : ''}
                                />
                                {
                                    smtpErros.senderEmail &&
                                    <div className="input-feedback">{smtpErros.senderEmail}</div>
                                }
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group controlId="senderName">
                                <Form.Label>Sender Name</Form.Label>
                                <Form.Control
                                    name="senderName"
                                    type="text"
                                    placeholder=""
                                    value={senderName}
                                    onChange={(e) => {
                                        setSenderName(e.target.value)
                                        setSmtpErrors({})
                                        setIsDirty() 
                                    }}
                                    onBlur={senderNameHandler}
                                    className={smtpErros.senderName ? 'error' : ''}
                                />
                                {
                                    smtpErros.senderName &&
                                    <div className="input-feedback">{smtpErros.senderName}</div>
                                }
                            </Form.Group>
                        </Col>
                    </Row>
                </div>
                <div className='settings-div'>
                    <Row>
                        <Col sm={6}>
                            <div>
                                <h4>SMTP settings</h4>
                                <Form className="logInForm smtpForm" onSubmit={handleSmtpForm}>
                                    {/*  */}
                                    <Row className="mb-4">
                                        <Form.Group as={Col} md="12" controlId="smtpuserName">
                                            <Form.Label>Username</Form.Label>
                                            <Form.Control
                                                name="smtpuserName"
                                                type="text"
                                                value={smtpUserName}
                                                onChange={(e) => {
                                                    setSmtpUserName(e.target.value)
                                                    setSmtpErrors({})
                                                    setIsDirty() 
                                                }}
                                                onBlur={smtpUserNameHandler}
                                                className={smtpErros.smtpUserName ? 'error' : ''}
                                            />
                                            {
                                                smtpErros.smtpUserName &&
                                                <div className="input-feedback">{smtpErros.smtpUserName}</div>
                                            }
                                        </Form.Group>
                                    </Row>

                                    <Row className="mb-4">
                                        <Form.Group className="pwd-wrapper" as={Col} md="12" controlId="smtppassword">
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control
                                                name="smtppassword"
                                                type={smtpPasswordShown ? "text" : "password"}
                                                value={smtpPassword}
                                                onChange={(e) => {
                                                    setSmtpPassword(e.target.value)
                                                    setSmtpErrors({})
                                                    setIsDirty() 
                                                }}
                                                onBlur={smtpPasswordHandler}
                                                className={smtpErros.smtpPassword ? 'error' : ''}
                                            />
                                            <span className={smtpPasswordShown ? "hide-pwd password-show" : "show-pwd password-show"} onClick={toggleSmtpPassword}><img className="view-icon" src={EyeIcon} alt="view" /></span>
                                            {
                                                smtpErros.smtpPassword &&
                                                <div className="input-feedback">{smtpErros.smtpPassword}</div>
                                            }
                                        </Form.Group>
                                    </Row>

                                    <Row className="mb-4">
                                        <Form.Group as={Col} md="12" controlId="smtpserverAddress">
                                            <Form.Label>Server Address</Form.Label>
                                            <Form.Control
                                                name="smtpserverAddress"
                                                type="text"
                                                value={smtpServeraddress}
                                                onChange={(e) => {
                                                    setSmtpServeraddress(e.target.value)
                                                    setSmtpErrors({})
                                                    setIsDirty() 
                                                }}
                                                onBlur={smtpServerAddressHandler}
                                                className={smtpErros.smtpServeraddress ? 'error' : ''}
                                            />
                                            {
                                                smtpErros.smtpServeraddress &&
                                                <div className="input-feedback">{smtpErros.smtpServeraddress}</div>
                                            }
                                        </Form.Group>
                                    </Row>

                                    <Row className="mb-4">
                                        <Form.Group as={Col} md="12" controlId="smtpPort">
                                            <Form.Label>Port (ie:465)</Form.Label>
                                            <Form.Control
                                                name="smtpPort"
                                                type="text"
                                                value={smtpPort}
                                                onChange={(e) => {
                                                    setSmtpPort(e.target.value)
                                                    setSmtpErrors({})
                                                    setIsDirty() 
                                                }}
                                                onBlur={smtpPortHandler}
                                                className={smtpErros.smtpPort ? 'error' : ''}
                                            />
                                            {
                                                smtpErros.smtpPort &&
                                                <div className="input-feedback">{smtpErros.smtpPort}</div>
                                            }
                                        </Form.Group>
                                    </Row>
                                    {/* <Row className="mb-4">
                                        <Form.Group className="terms-input" as={Col} md="12" controlId="smtpSSL">
                                            <Form.Control
                                                type="checkbox"
                                                name="smtpSSL"
                                                value={smtpSsl}
                                                onChange={(e) => setSmtpSsl(e.target.checked)}
                                            />
                                            <Form.Label>Enable SSL</Form.Label>
                                        </Form.Group>
                                    </Row> */}
                                    {
                                        loading ?
                                            <Button className='solid-button'>Test
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                            </Button>
                                            :
                                            <Button className='solid-button' type="submit" disabled={!smtpUserName || !smtpPassword || !smtpServeraddress || !smtpPort || !senderEmail || !senderName} >Test</Button>
                                    }

                                </Form>
                            </div>
                        </Col>
                        <Col sm={6}>
                            {/* <ImapForm imapFormData={imapFormData}/> */}
                            <div>
                                <h4>IMAP settings</h4>
                                <Form className="logInForm imapForm" onSubmit={handleImapForm} >
                                    {/*  */}
                                    <Row className="mb-4">
                                        <Form.Group as={Col} md="12" controlId="imapuserName">
                                            <Form.Label>Username</Form.Label>
                                            <Form.Control
                                                name="imapuserName"
                                                type="text"
                                                value={imapUserName}
                                                onChange={(e) => {
                                                    setImapUserName(e.target.value)
                                                    setImapErrors({})
                                                    setIsDirty() 
                                                }}
                                                onBlur={imapUserNameHandler}
                                                className={smtpErros.imapUserName ? 'error' : ''}
                                            />
                                            {
                                                imapErros.imapUserName &&
                                                <div className="input-feedback">{imapErros.imapUserName}</div>
                                            }
                                        </Form.Group>
                                    </Row>

                                    <Row className="mb-4">
                                        <Form.Group className="pwd-wrapper" as={Col} md="12" controlId="imappassword">
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control
                                                name="imappassword"
                                                type={imapPasswordShown ? "text" : "password"}
                                                value={imapPassword}
                                                onChange={(e) => {
                                                    setImapPassword(e.target.value)
                                                    setImapErrors({})
                                                    setIsDirty() 
                                                }}
                                                onBlur={imapPasswordHandler}
                                                className={smtpErros.imapPassword ? 'error' : ''}
                                            />
                                            <span className={imapPasswordShown ? "hide-pwd password-show" : "show-pwd password-show"} onClick={toggleImapPassword}><img className="view-icon" src={EyeIcon} alt="view" /></span>
                                            {
                                                imapErros.imapPassword &&
                                                <div className="input-feedback">{imapErros.imapPassword}</div>
                                            }
                                        </Form.Group>
                                    </Row>

                                    <Row className="mb-4">
                                        <Form.Group as={Col} md="12" controlId="imapserverAddress">
                                            <Form.Label>Server Address</Form.Label>
                                            <Form.Control
                                                name="imapserverAddress"
                                                type="text"
                                                value={imapServeraddress}
                                                onChange={(e) => {
                                                    setImapServeraddress(e.target.value)
                                                    setImapErrors({})
                                                    setIsDirty() 
                                                }}
                                                onBlur={imapServerAddressHandler}
                                                className={smtpErros.imapServeraddress ? 'error' : ''}
                                            />
                                            {
                                                imapErros.imapServeraddress &&
                                                <div className="input-feedback">{imapErros.imapServeraddress}</div>
                                            }
                                        </Form.Group>
                                    </Row>

                                    <Row className="mb-4">
                                        <Form.Group as={Col} md="12" controlId="imapPort">
                                            <Form.Label>Port (ie:993)</Form.Label>
                                            <Form.Control
                                                name="imapPort"
                                                type="text"
                                                value={imapPort}
                                                onChange={(e) => {
                                                    setImapPort(e.target.value)
                                                    setImapErrors({})
                                                    setIsDirty() 
                                                }}
                                                onBlur={imapPortHandler}
                                                className={smtpErros.imapPort ? 'error' : ''}
                                            />
                                            {
                                                imapErros.imapPort &&
                                                <div className="input-feedback">{imapErros.imapPort}</div>
                                            }
                                        </Form.Group>
                                    </Row>
                                    {/* <Row className="mb-4">
                                        <Form.Group className="terms-input" as={Col} md="12" controlId="imapSSL">
                                            <Form.Control
                                                type="checkbox"
                                                name="imapSSL"
                                                value={smtpPort}
                                                onChange={(e) => setImapSsl(e.target.checked)}
                                            />
                                            <Form.Label>Enable SSL</Form.Label>
                                        </Form.Group>
                                    </Row> */}

                                    {/* IMAP TEST BUTTON */}
                                    {/* <Button className='solid-button' type="submit" >Test</Button> */}
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className='save-btn'>
                    {
                        createLoading ?
                            <button className='solid-button'>Save &nbsp;
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            </button>
                            :
                            <button className='solid-button' onClick={handleSave} disabled={!smtpTested || !smtpSaved} >Save</button>
                            // <button className='solid-button' onClick={handleSave}  >Save</button>
                    }
                    {/* <button className='choose-btn' onClick={() => setSmShow(true)}>Choose another email provider</button> */}
                    <Modal
                        size="md"
                        className='warning-modal'
                        show={smShow}
                        onHide={() => setSmShow(false)}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        <Modal.Body>
                            <div className='warning-div'>
                                <img src={warningIcon} alt="warning" />
                                <h2>Remove SMTP and IMAP</h2>
                                <p>Removing your SMTP and IMAP could stop your campaigns if you're using this set up. Are you sure?
                                </p>
                                <div className='btn-container'>
                                    <button className='cancel-btn' onClick={() => setSmShow(false)}>Cancel</button>
                                    <button className='solid-button' onClick={handleUnlink} >Unlink Now</button>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
        </div>
        {Prompt}
    </>;
}

export default withRouter(Smtp);
